import React, { useState, useRef } from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';

import { FormFieldWrapper } from '@plone/volto/components';

interface SizeWidgetProps {
  id: string;
  title?: string;
  description?: string;
  required: boolean;
  value?: string;
  onChange: Function;
  wrapped: boolean;
  sizes: Array<{ value: string; title: string }>;
  block: string;
  disabled: boolean;
}

const SizeWidget: React.FC<SizeWidgetProps> = (data) => {
  const intl = useIntl();
  const defaultSizes = [
    { value: 's', title: 'S' },
    { value: 'm', title: 'M' },
    { value: 'l', title: 'L' },
  ];
  const sizes = data.sizes || defaultSizes;

  return (
    <FormFieldWrapper {...data} id="image_size">
      <div className="field-image_size">
        {sizes.map((size) => (
          <Button.Group>
            <Button
              icon
              basic
              aria-label={size.title}
              onClick={() => data.onChange(data.id, size.value)}
              active={data.value === size.value}
              disabled={data.disabled}
            >
              <div className="sizes-text">{size.title}</div>
            </Button>
          </Button.Group>
        ))}
      </div>
    </FormFieldWrapper>
  );
};

export default SizeWidget;
